import { all, fork } from 'redux-saga/effects';

import { effects as shipmentEffects } from 'state/direct-order/shipments';
import { effects as insuranceEffects } from 'state/direct-order/insurance';

export default function* directOrderSaga() {
  yield all([fork(insuranceEffects)]);
  yield all([fork(shipmentEffects)]);
}
